import * as actionTypes from '../actionTypes'

const inboundNumbers = (state = {
	inboundProgramNumbers: null,
	newInboundProgram: {},
	loadedProgram: {},
	rerender: false,
	shipTos: []
}, action) => {
	switch (action.type) {
		case actionTypes.FETCH_NUMBERS:
			return {
				...state,
				inboundProgramNumbers: action.numbers,
				open: false,
				openEdit: false,
				nameSearch: false,
				loadedProgram: {}
			}
		case actionTypes.NEW_INBOUND_PROGRAM: {
			let newInboundProgram = state.newInboundProgram
			newInboundProgram[action.field] = action.value
			return {
				...state,
				inboundNumbers: newInboundProgram
			}
		}
		case actionTypes.LOAD_SHIP_TO: {
			let editLoadedProgram = state.loadedProgram
			editLoadedProgram.shipTo = action.shipTo 
			return {
				...state,
				loadedProgram: editLoadedProgram,
				rerender: !state.rerender,
				shipToSearch: false
			}
		}
		case actionTypes.SHIP_TO_SEARCH_CHANGE_ACTION: {
			const name = action.value
			const field = action.field
			const shipTos = action.shipTos
			if (field === 'City') {
				return {
					...state,
					shipToSearchCity: name,
					shipTos: shipTos
				}
			} else {
				return {
					...state,
					shipToSearchState: name,
					shipTos: shipTos
				}
			}

		}
		case actionTypes.START_SEARCH_SHIP_ACTION: {
			return {
				...state,
				shipToSearch: true,
				shipTos: action.shipTos
			}
		}
		case actionTypes.NEW_CHANGE_CUSTOMER_NAME: {
			return {
				...state,
				nameSearch: action.possible.length > 0,
				potentialCustomers: action.possible
			}
		}
		case actionTypes.NEW_SELECT_INBOUND_PROGRAM: {
			let newInboundProgram = state.newInboundProgram
			newInboundProgram[action.field] = action.value
			return {
				...state,
				inboundNumbers: newInboundProgram,
				rerender: !state.rerender
			}
		}
		case actionTypes.BAD_INBOUND_SAVE: {
			return {
				...state,
				newInboundProgram: action.inboundProgram,
				rerender: !state.rerender,
				isSaving: false
			}
		}
		case actionTypes.BAD_INBOUND_EDIT_SAVE: {
			return {
				...state,
				loadedProgram: action.inboundProgram,
				rerender: !state.rerender,
			}
		}
		case actionTypes.ADD_INBOUND: {
			return {
				...state,
				nameSearch: false,
				open: true,
				newInboundProgram: {},
				isSaving: false,
			}
		}
		case actionTypes.CLOSE_INBOUND: {
			return {
				...state,
				open: false,
				newInboundProgram: {},
				isSaving: false
			}
		}
		case actionTypes.CLOSE_EDIT_INBOUND: {
			return {
				...state,
				openEdit: false,
				loadedProgram: {}, 
			}
		}
		case actionTypes.STARTING_INBOUND: {
			return {
				...state,
				isSaving: true
			}
		}
		case actionTypes.OPEN_EDIT: {
			return {
				...state,
				openEdit: true,
				loadedProgram: action.edit,
				shipToSearch: false
			}
		}
		case actionTypes.SAVE_INBOUND_EDIT: {
			return {
				...state,
				openEdit: false,
				loadedProgram: {}
			}
		}
		case actionTypes.CLOSE_EDIT: {
			return {
				...state,
				openEdit: false,
				loadedProgram: {}
			}
		}
		case actionTypes.LOAD_NEW_CUSTOMER: {
			let loadedProgram = state.newInboundProgram
			loadedProgram.customerName = action.name
			loadedProgram.billTo = action.billTo
			loadedProgram.accountTypeId = action.account
			return {
				...state,
				newInboundProgram: loadedProgram,
				rerender: !state.rerender
			}
		}
		case actionTypes.EDIT_INBOUND_PROGRAM: {
			let newInboundProgram = state.loadedProgram
			newInboundProgram[action.field] = action.value
			return {
				...state,
				loadedProgram: newInboundProgram,
				rerender: !state.rerender
			}
		}
		case actionTypes.EDIT_SELECT_INBOUND_PROGRAM: {
			let newInboundProgram = state.loadedProgram
			newInboundProgram[action.field] = action.value
			return {
				...state,
				loadedProgram: newInboundProgram,
				rerender: !state.rerender
			}
		}
		default:
			return state
	}
}

export default inboundNumbers


// WEBPACK FOOTER //
// ./src/reducers/inboundNumbers.js